import React, { useState } from 'react'
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import IndexContext from './IndexContext';
import { MainContext } from './contexts/MainContext'

const App = () => {
  
  const [cartItems, setCartItems] = useState([])
  const [catalogItems, setCatalogItems] = useState([])
  const [catalogItemsVariations, setCatalogItemsVariations] = useState([])
  const [userData, setUserData] = useState({})
  const [userWpData, setUserWpData] = useState({})
  const [recentlySeen, setRecentlySeen] = useState([])
  const [homePageData, setHomePageData] = useState({})
  const [pvz, setPvz] = useState([])
  const [headerMenuCategories, setHeaderMenuCategories] = useState([])
  const [brewingMethods, setBrewingMethods] = useState([])
  const [priceListPageSlug, setPriceListPageSlug] = useState('')

  return (
    <MainContext.Provider value={{ cartItems, setCartItems, catalogItems, setCatalogItems, catalogItemsVariations, setCatalogItemsVariations, userData, setUserData, userWpData, setUserWpData, recentlySeen, setRecentlySeen, homePageData, setHomePageData, pvz, setPvz, headerMenuCategories, setHeaderMenuCategories, brewingMethods, setBrewingMethods, priceListPageSlug, setPriceListPageSlug }}>
      <IndexContext />
    </MainContext.Provider>
  )
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
